import { CustomerDetailsSectionTitles } from 'components/customer-details-column/constants';
import { plural } from 'helpers/string';

export enum ChatSummaryStatus {
  Initial = 'initial',
  Generated = 'generated',
  Error = 'error',
}

export const ChatSummaryValidationRules = {
  minLength: 100,
} as const;

export enum ChatSummaryButtons {
  Cancel = 'Cancel',
  TryAgain = 'Try again',
  SummarizeChat = 'Summarize chat',
}

export enum ChatSummaryErrorMessages {
  MinLength = 'You can only summarize chats between agents and clients that are over 100 characters.',
  ServerResponse = "Sorry, the chat couldn't be summarized.",
  RetrievalFail = "Sorry, the summary couldn't be presented.",
}

export const ChatSummaryContent = {
  onboardingTooltip: {
    title: 'Summarize your chats',
    content: 'Now you can quickly summarize your chats using Artificial Intelligence.',
  },
  header: {
    title: CustomerDetailsSectionTitles.ChatSummary,
  },
  main: {
    initial: 'Summarize your chat in a simple list using AI.',
  },
  box: {
    created: (date: string) => `Created: ${date}`,
    updating: 'Updating summary.',
    mayTakeUpTo: 'This may take up to a minute.',
    copyAriaLabel: 'Copy chat summary',
    updateAriaLabel: 'Update chat summary',
    completeSummary: 'Complete',
    messageTitle: (count: number, isArchive: boolean) =>
      isArchive ? 'not included' : `${plural(count, 'new message', 'new messages')}`,
    messageCount: (count: number) =>
      `Last ${plural(count, "message isn't", `${count} messages aren’t`)}  included. Update summary to include ${plural(
        count,
        'it',
        'them',
      )}.`,
    chatSummarized: 'Entire chat summarized.',
    tooltip: {
      options: 'Options',
      copy: 'Copy',
      update: 'Update summary',
    },
  },
};
